import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Sectors from "@/components/Sectors";
import Approach from "@/components/Approach";
import CTABand from "@/components/CTABand";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { initLenis } from "@/lib/lenis";

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="bg-white text-[#12344E] min-h-screen antialiased overflow-x-clip">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Sectors />
        <Approach />
        <CTABand />
        <Contact />
      </main>
      <Footer />
      <Toaster theme="light" position="bottom-right" />
    </div>
  );
}

export default App;
